import React from "react";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import PistonSeal from "../../asset/pistonseal/1.png";
import MetallicSeal from "../../asset/metallicseal/1.png";
import PrecisionComponent from "../../asset/precisionone/poppet.png";
import Coating from "../../asset/coating/hardchrome.png";
import "./OurProducts.css";

const products = [
  {
    category: "Sealing solutions",
    title: "Piston Rod Seals",
    description: "High-performance seals engineered for demanding pressure and movement conditions.",
    image: PistonSeal,
    link: "/piston-rod-seals",
  },
  {
    category: "Sealing solutions",
    title: "Metallic Face Seals",
    description: "Leak-tight sealing solutions made for high-temperature and high-pressure applications.",
    image: MetallicSeal,
    link: "/metallic-face-seals",
  },
  {
    category: "Precision engineering",
    title: "Precision Components",
    description: "Special-grade alloy components and assemblies produced to exacting tolerances.",
    image: PrecisionComponent,
    link: "/precision-component",
  },
  {
    category: "Surface engineering",
    title: "SURFACE TREATED COMPONENTS",
    description: "Durable surface protection that improves wear resistance and component life.",
    image: Coating,
    link: "/coating-and-plating",
  },
];

const OurProducts = () => (
  <section className="our-products" aria-labelledby="our-products-title">
    <div className="our-products__heading">
      <div>
        <p className="our-products__eyebrow">What we make</p>
        <h2 id="our-products-title">Our products</h2>
      </div>
      <Link className="our-products__all-link" to="/products">
        View all products <ArrowUpRightIcon />
      </Link>
    </div>

    <div className="our-products__grid">
      {products.map((product) => (
        <Link to={product.link} className="product-card" key={product.title}>
          <div className="product-card__image"><img src={product.image} alt={product.title} /></div>
          <div className="product-card__body">
            <span>{product.category}</span>
            <h3>{product.title}</h3>
            <p>{product.description}</p>
            <ArrowUpRightIcon className="product-card__arrow" />
          </div>
        </Link>
      ))}
    </div>
  </section>
);

export default OurProducts;
